import type { CompanyDocument } from '@pn/core/domain/intel/document';
import { createSlice } from '@reduxjs/toolkit';

type CompanyDocumentState = {
  isFetching: boolean;
  isError: boolean;
  documents: CompanyDocument[];
};

const initialState: CompanyDocumentState = {
  isFetching: false,
  isError: false,
  documents: [],
};

const createCompanyDocumentsSlice = (sliceName: string) =>
  createSlice({
    name: sliceName,
    initialState,
    reducers: {
      request: (state) => {
        state.isFetching = true;
        state.isError = false;
      },
      receive: (state, { payload }) => {
        state.documents = payload;
        state.isFetching = false;
      },
      error: (state) => {
        state.isFetching = false;
        state.isError = true;
      },
      reset: (state) => {
        state.isFetching = false;
        state.isError = false;
        state.documents = [];
      },
    },
  });

export const companyDocumentsSlice =
  createCompanyDocumentsSlice('companyDocuments');
